import { render, staticRenderFns } from "./xm.vue?vue&type=template&id=509fe0a5&"
import script from "./xm.vue?vue&type=script&lang=js&"
export * from "./xm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports